






import Vue from 'vue';
import { UserDTO } from '@/api';

export default Vue.extend({
  name: 'avatar',
  props: {
    user: Object,
    size: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    styles() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        lineHeight: `${this.size}px`,
      };
    },
    userFirstChars() {
      const user = this.user as UserDTO;
      return user && user.firstName && user.surname ? user.firstName[0] + user.surname[0] : 'ГПБ';
    },
  },
});
